/**
 * 获取物理舱名称
 * @param {string} 南航舱位
 * @returns 对应的业务中文名称
 */
export default function getPhysicalCabinName(s) {
    switch (s) {
        case 'F':
        case 'First':
            return '头等舱';
        case 'J':
        case 'C':
        case 'D':
        case 'I':
        case 'O':
        case 'Business':
            return '公务舱';
        case 'W':
        case 'S':
        case 'PremiumEconomy':
            return '明珠经济舱';
        case 'Y':
        case 'B':
        case 'M':
        case 'H':
        case 'P':
        case 'K':
        case 'U':
        case 'A':
        case 'L':
        case 'Q':
        case 'E':
        case 'V':
        case 'Z':
        case 'T':
        case 'N':
        case 'R':
        case 'G':
        case 'X':
        case 'Economy':
            return '经济舱';
        default:
            break;
    }
}



//////////////////
// WEBPACK FOOTER
// ../emp-helpers/dist/es/business/getPhysicalCabinName.js
// module id = null
// module chunks = 